// extracted by mini-css-extract-plugin
export default {"divSinPlatos":"SinPlatos_divSinPlatos__a9OOV","title":"SinPlatos_title__UA8t5"};